import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  Book,
  Download,
  Edit,
  Filter,
  Save,
  TrendingUp,
  X,
  XCircle,
} from "react-feather";
import PropTypes from "prop-types";
import EmployeeHeader from "./Details/Header";
import EmployeeInformationDetails from "./Details/EmployeeInformation";
import PersonalInformationDetails from "./Details/PersonalInformation";
import SalaryDetails from "./Details/SalaryDetail";
import BankDetails from "./Details/BankDetails";
import PassDetails from "./Details/PassDetail";
import PassportDetails from "./Details/PassportDeatils";
import AllowanceAndDeductionDetails from "./Details/AllowanceAndDeduction";
import WorkingHoursDetails from "./Details/WorkingHoursDetails";
import EducationDetails from "./Details/EductionDetails";
import WorkExperienceDetails from "./Details/WorkExperienceDetails";
import VisaDetails from "./Details/VisaDetails";
import InventoryDetails from "./Details/InventroryDetail";
import CCDetails from "./Details/CCDetails";
import AccomendationDetails from "./Details/AccomendationDetails";
import KidsDetails from "./Details/KidsDetail";
import DependantDetails from "./Details/DependantDetails";
import ImageSection from "./Details/ImageSection";
import "../../style/css/employee-profile.css";
import { Modal } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import ContractDetails from "./Details/ContractDetails";
const PreviewEmployee = ({
  mode = "I",
  onSubmit,
  onError,
  show = false,
  handleClose,
  status = false
}) => {
  const componentRef = useRef();
  const {
    getValues,
    handleSubmit,
    formState: { isSubmitting },
  } = useFormContext();

  const employeeDetails = getValues();

  /* ---------------- DEFAULT SECTIONS ---------------- */
  const defaultSections = {
    employeeInfo: true,
    personalInfo: true,
    pass: true,
    passport: true,
    salary: true,
    bank: true,
    allowance: true,
    education: true,
    work: true,
    visa: true,
    inventory: true,
    course: true,
    accommodation: true,
    kids: true,
    dependants: true,
    workingHourDetails: true,
    images: true,
    contract : true
  };


  const [selectedSections, setSelectedSections] = useState(defaultSections);

  const handleCheckboxChange = (key) => {
    setSelectedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  /* ---------------- SECTION GROUPS ---------------- */
  const sectionGroups = [
    {
      title: "Basic Information",
      sections: [
        ["employeeInfo", "Employee Info"],
        ["personalInfo", "Personal Info"],
        ["workingHourDetails", "Working Hours"],
      ],
    },
    {
      title: "Employment & Payroll",
      sections: [
        ["salary", "Salary"],
        ["bank", "Bank"],
        ["allowance", "Allowance"],
        ["education", "Education"],
        ["work", "Work Experience"],
      ],
    },
    {
      title: "Documents & Compliance",
      sections: [
        ["pass", "Pass"],
        ["passport", "Passport"],
        ["visa", "Visa"],
        ["course", "Course"],
        ["inventory", "Inventory"],
      ],
    },
    {
      title: "Family & Accommodation",
      sections: [
        ["accommodation", "Accommodation"],
        ["kids", "Kids"],
        ["dependants", "Dependants"],
      ],
    },
    {
      title: "Media",
      sections: [["images", "Images"]],
    },
  ];

  /* ---------------- PRINT ---------------- */
  const handleEmployeePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: `${employeeDetails?.fullName}-Profile`,
    pageStyle: `
      @media print {
        .page-header, .accordion {
          display: none !important;
        }
        * {
          overflow: visible !important;
        }
      }
    `,
  });

  return (
    <Modal show={show} onHide={handleClose} animation centered size="xl">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Employee Details Preview</h4>
        </div>
        <div style={{ display: "inline-flex" }}>
          <button
            type="submit"
            className="btn btn-added"
            onClick={handleSubmit(onSubmit, onError)}
            disabled={status}
          >
            {/* <span aria-hidden="true">×</span> */}
            {status ? (
              <>
                <i className="fas fa-spinner fa-spin me-2" /> Loading...
              </>
            ) : (
              <>
                <Save className="me-2" />
                {mode === "I" ? "Save" : "Update"}
              </>
            )}
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={status}
          >
            <XCircle className="me-2" size={18} />
            Close
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* ---------------- DETAILS ---------------- */}
        {employeeDetails && (
          <div ref={componentRef}>
            <div className="card border-0">
              <div className="card-body">
                <div className="row">
                  <EmployeeHeader employee={employeeDetails} />

                  {selectedSections.employeeInfo && (
                    <div className="col-md-6">
                      <EmployeeInformationDetails employee={employeeDetails} />
                    </div>
                  )}

                  {selectedSections.personalInfo && (
                    <div className="col-md-6">
                      <PersonalInformationDetails employee={employeeDetails} />
                    </div>
                  )}

                  {selectedSections.salary && (
                    <div className="col-md-6">
                      <SalaryDetails employee={employeeDetails} />
                    </div>
                  )}

                  {selectedSections.bank && (
                    <div className="col-md-6">
                      <BankDetails employee={employeeDetails} />
                    </div>
                  )}

                  {selectedSections.pass && (
                    <PassDetails employee={employeeDetails} />
                  )}
                  {selectedSections.passport && (
                    <PassportDetails employee={employeeDetails} />
                  )}
                  {selectedSections.allowance && (
                    <AllowanceAndDeductionDetails employee={employeeDetails} />
                  )}
                  {selectedSections.workingHourDetails && (
                    <WorkingHoursDetails employee={employeeDetails} />
                  )}
                  {selectedSections.education && (
                    <EducationDetails employee={employeeDetails} />
                  )}
                  {selectedSections.work && (
                    <WorkExperienceDetails employee={employeeDetails} />
                  )}
                  {selectedSections.visa && (
                    <VisaDetails employee={employeeDetails} />
                  )}
                  {selectedSections.contract && (
                    <ContractDetails employee={employeeDetails} />
                  )}
                  {selectedSections.inventory && (
                    <InventoryDetails employee={employeeDetails} />
                  )}
                  {selectedSections.course && (
                    <CCDetails employee={employeeDetails} />
                  )}
                  {selectedSections.accommodation && (
                    <AccomendationDetails employee={employeeDetails} />
                  )}
                  {selectedSections.kids && (
                    <KidsDetails employee={employeeDetails} />
                  )}
                  {selectedSections.dependants && (
                    <DependantDetails employee={employeeDetails} />
                  )}
                </div>
              </div>
            </div>

            {selectedSections.images && (
              <div className="card border-0 mt-3">
                <div className="card-header">
                  <h4 className="card-title">Employee Documents</h4>
                </div>
                <div className="card-body">
                  <ImageSection employee={employeeDetails} />
                </div>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

PreviewEmployee.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  status : PropTypes.bool
};

export default PreviewEmployee;
